<template>
<div style="padding-top: 15px;">
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;margin:0 !important;">
             
                  <el-button type="primary" @click="openQuiz">EXPORT - SUMMARY </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      dialogTableVisible:false,
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      total:0,
      rows:[],
      startDate:"",
      endDate:"",
      ocTable:"",
      ocAction:"",
      multipleSelection:[],
      sortType:"DESC",
      sortField:"id",
      showDetail:false,
      compareDetail:[],
      lastPublishDate:"",
      lastPublisher:""

    };
  },
  created() {

  },
  components: {
    draggable,
  }, 
  methods: {
    async openQuiz(){
      const link = document.createElement("a");
      link.href = `https://quiz.jpc.org.hk/jpc_feedback_summary`;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async uploadFile(params) {
    
    },
  },
  mounted() {
  }
};
</script>
